import axios from 'axios'

// 本站全局拦截器会解包响应，上传申请和确认使用独立实例保留原始响应结构。
const siteClient = axios.create({ timeout: 30000 })
const directClient = axios.create({ timeout: 180000, withCredentials: false })

/** Element 上传适配：沿用原成功回调，文件直传时不发送本站凭证。 */
export default function projectUpload(options) {
  const cancel = axios.CancelToken.source()
  const promise = (async () => {
    const file = options.file
    if (!file.size || file.size > 20 * 1024 * 1024) throw new Error('文件不能为空或超过20MB')
    const action = new URL(options.action, location.href)
    const base = action.origin + '/api/front/file/upload/'
    const headers = { H5TOKEN: localStorage.getItem('token') || '' }
    const purpose = action.searchParams.get('ftype') || action.searchParams.get('fdir') || (action.pathname === '/api/front/upload/' ? 'avatar' : 'refer')
    const prepared = await siteClient.post(base + 'prepare/', {
      purpose_dir: purpose, file_name: file.name, file_size: file.size, target: purpose === 'avatar' ? 'avatar' : 'temporary',
    }, { headers, timeout: 30000, cancelToken: cancel.token })
    if (Number(prepared.data.status) !== 200) throw new Error(prepared.data.message || '获取上传地址失败')
    const ticket = prepared.data.data
    const form = new FormData()
    form.append('file', file)
    const uploaded = await directClient.post(ticket.upload_url, form, {
      params: { cover_width: ticket.cover_width }, cancelToken: cancel.token,
      onUploadProgress: event => {
        if (event.total) options.onProgress({ percent: Math.min(95, Math.round(event.loaded * 95 / event.total)) })
      },
    })
    if (![0, 200].includes(Number(uploaded.data.code)) || !uploaded.data.data || !uploaded.data.data.file_url) {
      throw new Error(uploaded.data.msg || '文件直传失败')
    }
    const confirmed = await siteClient.post(base + 'save/', {
      upload_context: ticket.upload_context, file: uploaded.data.data,
    }, { headers, timeout: 180000, cancelToken: cancel.token })
    if (Number(confirmed.data.status) !== 200) throw new Error(confirmed.data.message || '上传确认失败')
    options.onProgress({ percent: 100 })
    return action.pathname === '/api/front/suno/music/upload/'
      ? { ...confirmed.data, img_url: confirmed.data.data.cdn_full_url }
      : confirmed.data
  })()
  promise.then(options.onSuccess, options.onError)
  return { abort: () => cancel.cancel('上传已取消') }
}
